import Vue from 'vue';

Vue.prototype.$getPageUrl = function (page) {
  if (this.$isExternalUrl(page)) {
    return page;
  }

  let [urlPath, urlQuery] = page.split('?');
  const urlParams = new URLSearchParams(urlQuery);

  for (const k in this.$route.query) {
    if (!urlParams.has(k)) {
      urlParams.set(k, this.$route.query[k]);
    }
  }

  const segments = urlPath.split('/').filter((i) => i);

  urlPath = '/' + segments.join('/');

  const query = urlParams.toString();

  const url = urlPath + (query ? `?${query}` : '');

  return url;
};

Vue.prototype.$isExternalUrl = function (value) {
  return value && (value.startsWith('http') || value.startsWith('//'));
};

Vue.prototype.$wait = function (time = 0) {
  return new Promise((resolve) => {
    this.$nextTick().then(() => {
      if (process.client) {
        window.requestAnimationFrame(() => {
          setTimeout(resolve, time);
        });
      } else {
        setTimeout(resolve, time);
      }
    });
  });
};

Vue.prototype.$showLoading = function (visible) {
  if (visible) {
    this.$nuxt.$loading.start();
  } else {
    this.$nuxt.$loading.finish();
  }
};
